AddPageSwapTrigger(function(){
	var timer;
    $(".nav-tabs > li.tabsubnav ").off('mouseenter');
    $(".nav-tabs > li.tabsubnav ").off('mouseleave');
    $("ul.nav-tabs.nav-stacked").off('mouseleave');
    $(".nav-tabs > li.notabsubnav ").off('mouseenter');
    $(".nav-tabs > li.notabsubnav ").off('mouseleave');

	$(".nav-tabs > li.tabsubnav ").mouseenter(function() {
		var self = this;		
		$('.tab-pane.activehide').addClass("active");
		$('.tab-pane.activehide.active').removeClass("activehide");
		$('ul.tabnavhover').removeClass("tabnavhover");
		$('a.tabnavhover').removeClass("tabnavhover");		
		timer = setTimeout(function() {
			$(self).find('a').trigger('click');
			$(self).find('ul').addClass('tabnavhover');
			$(self).find('a').addClass('tabnavhover');
			$('.tab-pane#nav_none').removeClass("active");
		}, 100);
	});
	$(".nav-tabs > li.tabsubnav ").mouseleave(function() {
		clearTimeout(timer);
	});
	$("ul.nav-tabs.nav-stacked").mouseleave(function() {
		$('ul.nav-tabs.nav-stacked').addClass('tabnavhover');
		$('ul.nav-tabs.nav-stacked li.active a').addClass('tabnavhover');
	});
	$(".nav-tabs > li.notabsubnav ").mouseenter(function() {
		timer = setTimeout(function() {
			$('.tab-pane.active').addClass("activehide");
			$('.tab-pane.active.activehide').removeClass("active");
			$('.tab-pane#nav_none').addClass("active");
		}, 100);
		$('ul.nav-tabs.nav-stacked.tabnavhover').removeClass("tabnavhover");
		$('a.tabnavhover').removeClass("tabnavhover");
	});
	$(".nav-tabs > li.notabsubnav ").mouseleave(function() {
		clearTimeout(timer);
	});
});

AddPageSwapTrigger(function(){
    $("#dropdownmegamenu a.dropdownmegamenu-toggle").off('mouseleave');
    $('#dropdownmegamenu a.dropdownmegamenu-toggle').off('click');
	$("#dropdownmegamenu2 a.dropdownmegamenu-toggle").off('mouseleave');
    $('#dropdownmegamenu').off('hover');
	$("#dropdownmegamenu2 a.dropdownmegamenu-toggle").off('click');
	$('#dropdownmegamenu2').off('hover');
	$('#dropdownmegamenu .tab-content a').off('click');
    $('#dropdownmegamenu a.dropdown-toggle').off('mousemove');
	$('#dropdownmegamenu2 .dropdown-menu a').off('click');

	$("#dropdownmegamenu a.dropdownmegamenu-toggle").mouseleave(function(){ $('#dropdownmegamenu').removeClass("open"); });
	$("#dropdownmegamenu a.dropdownmegamenu-toggle").click(function(){ $('#dropdownmegamenu').removeClass("open"); });
	$("#dropdownmegamenu2 a.dropdownmegamenu-toggle").mouseleave(function(){ $('#dropdownmegamenu2').removeClass("open"); });
	$("#dropdownmegamenu2 a.dropdownmegamenu-toggle").click(function(){ $('#dropdownmegamenu2').removeClass("open"); });
	
	$('#dropdownmegamenu .tab-content a').click(function() {
		$('#dropdownmegamenu').addClass("mmhide");
		$('#wrapper').removeClass("dropdownmainhover");
	});
	$('#dropdownmegamenu2 .dropdown-menu a').click(function() {
		$('#dropdownmegamenu2').addClass("mmhide");
		$('#wrapper').removeClass("dropdownmainhover");
	});
	$('#nav_none').hover(function() {
		$('#dropdownmegamenu').addClass("mmhide");
		$('#wrapper').removeClass("dropdownmainhover");
	});
	$('#dropdownmegamenu').hover(function() {
		$('#dropdownmegamenu').removeClass("mmhide");
		$('#dropdownmegamenu').removeClass("open");
	});
	$('#dropdownmegamenu2').hover(function() {
		$('#dropdownmegamenu2').removeClass("mmhide");
		$('#dropdownmegamenu2').removeClass("open");
	});
	$('#dropdownmegamenu a.dropdown-toggle').mousemove(function() {
		$('.tab-pane').removeClass("active");
		$('ul.nav-tabs.nav-stacked li').removeClass("active");
		$('ul.nav-tabs.nav-stacked.tabnavhover').removeClass("tabnavhover");
		$('ul.nav-tabs.nav-stacked li a.tabnavhover').removeClass("tabnavhover");
	});
});	